import { Button, Drawer, Typography } from "@mui/material";
import { createContext, useRef, useState} from "react";
import { Colors, Variables } from "../../misc/variables";
import ClearIcon from '@mui/icons-material/Clear';
import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import { FormHandler } from "../../hooks/builder/form";
import store, { clear, reload, setFieldState } from "../store/formStore";
import { useBuilder } from "../../hooks/useBuilder";
import { LoadingButton } from "@mui/lab";
import { useSnackBar } from "./consumers/useSnackBar";
import { AuthHelper } from "../controllers/AuthHelper";
import moment from "moment";

export const DashboardContext = createContext();


const ReturnElement = (props) => {
  const ref = useRef();
  const element = <div ref={ref}><FormHandler 
  {...props}
  label={props.label} 
  placeholder={`Inserisci ${props.label}`} 
/></div>
  return element 
}

export const DashboardDrawerProvider = ({ children, routerContext }) => {
  useSelector(state => state.subSelected);

  const [defaultOpen, setDefaultOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [width, setWidth] = useState(Variables.drawerWidth)
  const [elementArray, setElementArray] = useState(undefined)

  // const [width, setWidth] = useState(window.innerWidth);
  let [refs, setRefs] = useState([]);
  let [refresh, setRefresh] = useState(undefined);


  const elements = useSelector(state => state.elements);
  const formObject = useSelector(state => state.request);
  const values = useSelector(state => state.fieldsData);
  
  useSelector(state => state.committenti);
  const [formState, setFormState] = useState({});

  const [customers, setCustomers] = useState([]);

  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  // }, [elements])

  const { builder } = useBuilder();

  const pushMobileOpen = (param, _width, _title, _elements) => { 
    setDefaultOpen(param);
    setWidth(_width);
    setTitle(_title);
    setElementArray(_elements);
  };

  const { addAlert } = useSnackBar();

  let navigate = null;
  const addRouter = (param) => {navigate = param};

  const groupFields = async (...params) => {
    const groupFieldParams = params[1];
    const fieldsToIsolate = _.chunk(params[0].filter(x => x.name.includes(groupFieldParams.identifier))
                                        .map(x => ({
                                            name: x.name.split(`${groupFieldParams.identifier}_`)[1],
                                            value: x.value})), groupFieldParams.subfields.length);
    let cleanFields = {}; 
    params[0].filter(x => !x.name.includes(groupFieldParams.identifier))
              .forEach(x => cleanFields[x.name] = x.value);
    cleanFields[groupFieldParams.name] = fieldsToIsolate;
    return cleanFields;
  }
  const sendRequest = async(url, method, fields, groupFieldByName) => {
    setLoading(true);
    const apiKey = localStorage.getItem('cruddy-apiKey')
    const subCurrent = (await AuthHelper.getUserFromIdToken(apiKey)).Username;
    
    let response; // visibile in tutto il blocco
    
    try{
      let payload = values
      //CHECK REQUIRED
      for(let element of elements){
        const _element = JSON.parse(element);
        if(_element.required && !payload[_element.fieldName]){
          alert(`Il campo ${_element.label} è obbligatorio`)
          setLoading(false);
          return;
        }

        if(_element.regex && !RegExp(_element.regex).test(values[_element.fieldName])){
          alert(`Il formato di ${_element.label} non è corretto`);
          setLoading(false);
          return;
        }
      }

      if(groupFieldByName){
        payload = await groupFields(payload, groupFieldByName);
      }
      
      if(method === 'PUT' || title.toLowerCase().includes('modifica')){
        if(url.includes('{id}'))url = url.replace('{id}', payload.id)
        else {
          url = `${url}/${payload.id}`;
          method = 'PUT';
        }
      }

      const _sendRequest = await fetch(url, {
        method: method,
        body: (method === 'POST' || method === 'PUT') ? JSON.stringify({...payload, user: subCurrent, assigned: subCurrent}) : undefined
      });
     
      response =  await _sendRequest.json();

      if(_sendRequest.status === 500){
        addAlert({
          message: response.message,
          severity: 'error'
        });
        setLoading(false);
        return;
      }
      addAlert({
        message: 'Richiesta inviata con successo',
        severity: 'success'
      })
      setLoading(false);
      setDefaultOpen(false);
      store.dispatch(clear());
      store.dispatch(reload());
      if(!url.includes('courses') && !url.includes('course')) 
        window.setTimeout(() => window.location.reload(), 500);
        
      
    }catch(ex){
      setLoading(false);
      addAlert({
        message: response.message,
        severity: 'error'
      })
    }
  }

  const controlledHandler = async (isSignup) => {
    setLoading(true);
    if(isSignup){
      try{
        const res = await AuthHelper.signUp(values.email, values.password, values.firstName, values.lastName, values.schoolName, values.website, values.città, values.address);
        setLoading(false);
        addAlert({
          message: 'Utente registrato con successo',
          severity: 'success'
        })
        window.setTimeout(() => window.location.reload(), 500);
      }catch(ex){
        setLoading(false);
        addAlert({
          message: 'Errore server',
          severity: 'error'
        });
      }
      
    }
  }
  
  return (
    <DashboardContext.Provider value={{pushMobileOpen, defaultOpen, addRouter}}>
      {children}
      <Drawer
        sx={{
          width: width,
          flexShrink: 0,
          backgroundColor: `${Colors.primaryColor} !important`,
          '& .MuiDrawer-paper': {
            width: width,
            boxSizing: 'border-box',
          },
        }}
        PaperProps={{
          sx: {backgroundColor: `#fff !important`, border: 0, boxShadow: '-3px 0 8px 0 rgb(66 91 118 / 21%);'}
        }}
        variant="persistent"
        anchor="right"
        open={defaultOpen}>
          <div style={{background: 'linear-gradient(to bottom right, #9DCEE2, #7256CB)', minHeight: 80, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '2rem', paddingRight: '2rem'}}>
            <Typography variant="h5" fontWeight={700} color="#fff">{title}</Typography>
            <Button sx={{color: '#fff'}} onClick={() => {setDefaultOpen(false); store.dispatch(clear()); setRefs([])}}>
              <ClearIcon></ClearIcon>
            </Button>
          </div>
          <div style={{padding: '2rem'}}>
              {/* {element && Object.keys(element.fields).map(field => <div style={{paddingTop: '1rem'}}>{element.fields[field].element}</div>)} */}
              {elements.map((element, index) => {
                const _element = JSON.parse(element);

                let customizedRegex;

                if(_element.label === 'Plico'){
                  customizedRegex = true;
                }
                return <div key={`form-index-${index}`}>
                  <ReturnElement {..._element} label={_element.label} 
                  error={!customizedRegex ? (values[_element.fieldName]?.length > 0 && _element.regex && !RegExp(_element.regex).test(values[_element.fieldName])) : values[_element.fieldName]?.length !== Number(customers.filter(x => x.name === values['Committente'])[0]?.lunghezza_plico)}
                  helperText={!customizedRegex ? values[_element.fieldName]?.length > 0 && _element.regex && !RegExp(_element.regex).test(values[_element.fieldName]) ? "Formato non corretto." : null  : values[_element.fieldName]?.length !== Number(customers.filter(x => x.name === values['Committente'])[0]?.lunghezza_plico) ? 'Formato non corretto' : null}
                  value={values[_element.fieldName]} sx={{marginBottom: 48}} 
                  filter={_element.filter}
                  onChange={async (e) => {
                    console.log()
                  if(e.target){
                    store.dispatch(setFieldState({name: _element.fieldName, value: e.target.value}))
                    if(e.target.hasOwnProperty('checked') && _element.type !== "checkbox"){ 
                      builder(_element.subforms?.filter(x => x.label === e.target.value)[0].form, _element.subforms?.filter(x => x.label === e.target.value)[0])
                    }
                  }else{
                    if(moment(e).isValid){
                      console.log(moment(e));
                      store.dispatch(setFieldState({name: _element.fieldName, value: e.format('YYYY-MM-DDT00:00:00')}))
                    }else{
                      store.dispatch(setFieldState({name: _element.fieldName, value: e}))

                    }
                  }
                 
                }} /></div>
              })}
              {/* 4° parametro sono i dati da passare alla richiesta */}
              <LoadingButton type="submit" variant="contained" loading={loading} color="primary" onClick={() => formObject.isControlled ? controlledHandler(true) : sendRequest(formObject.url, formObject.method, null)} fullWidth>Invia</LoadingButton>
          </div>
        
          
      </Drawer>
    </DashboardContext.Provider>
  )
}